import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tax-form-popup',
  templateUrl: './tax-form-popup.component.html',
  styleUrls: ['./tax-form-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxFormPopupComponent implements OnInit {
  form!: FormGroup;
  head = ['показатель', 'Частота расчета', 'Срок уплаты'];

  get formControls() {
    return this.form.controls;
  }

  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<TaxFormPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { taxblock: { [key: string]: string }; name: string },
  ) {}

  ngOnInit() {
    const controls: { [key: string]: FormGroup } = {};
    for (const key in this.data.taxblock) {
      controls[key] = this._fb.group({
        frequency: ['', []],
        term: ['', []],
      });
    }
    this.form = this._fb.group(controls);
  }

  formGroups(key: string): FormGroup {
    return this.form.controls[key] as FormGroup;
  }

  save() {
    this.dialogRef.close({
      value: this.form.value,
    });
  }

  close() {
    this.dialogRef.close();
  }

  updatetax(control: string, value: Event) {}
}
